import React from "react";

type CardProps = React.HTMLAttributes<HTMLDivElement>;

export const Card = ({ className = "", style, ...props }: CardProps) => {
  return (
    <div
      className={className}
      style={{
        border: "1px solid var(--color-border)",
        background: "var(--color-bg-panel)",
        borderRadius: "16px",
        ...style,
      }}
      {...props}
    />
  );
};
